export default __webpack_public_path__ + "img/hamburguer-menu.svg";